import api from '../store/apiClient';

/**
 * Public coupon validation (same contract as shop `client` / server `couponController.validateCoupon`).
 * @param {string} code
 * @param {number} subtotal
 * @param {Array<{ product?: { mongoId?: string, id?: string, price?: number }, qty?: number }>} cartItems
 */
export async function validateCoupon(code, subtotal = 0, cartItems = []) {
  const body = { code: String(code).trim(), subtotal: Number(subtotal) || 0 };
  if (cartItems.length > 0) {
    body.items = cartItems.map((i) => ({
      productId: i.product?.mongoId || i.product?.id,
      quantity: i.qty || 1,
      price: i.product?.price ?? 0,
    }));
  }
  const { data } = await api.post('/coupons/validate', body);
  return data;
}
